<template>
  <b-tab :title="(collection && collection.name ? collection.name : 'N/A') + ' (' + amount_selected + ')'" class="pb-0">
    <b-row class="pr-3" align-h="end">
      <b-col>
        <h3>Select Instrument(s)</h3>
      </b-col>
      <b-col v-if="instrument_collection.models.length" cols="2" class="px-0 pb-3">
        <b-button variant="success" block @click="handleToggleAllClick"><i :class="is_all_checked ? 'fa fa-check-square' : 'fa fa-square'" />
          Toggle All</b-button>
      </b-col>
    </b-row>
    <b-row v-if="instrument_collection.models.length" class="pr-3">
      <schedule-select-button v-for="(instrument_instance, index) in instrument_collection.models" :key="index" :item="instrument_instance" :isActive="!!(
          selected_tools && selected_tools.tools.hasByID(instrument_instance)
        )
        " :label="formatInstanceName(instrument_instance)" icon="flask" @onClick="handleFormUpdate" />
    </b-row>
    <b-row v-else-if="collection.inspecific_scheduling" class="pr-3">
      <schedule-select-button :key="0" :item="instrumentlessInstrument" :isActive="!!(
          selected_tools && selected_tools.tools.hasByID(null)
        )
        " :label="'No Equipment'" icon="flask" @onClick="handleFormUpdate" />
    </b-row>
    <b-alert v-else show class="py-1 mb-3"> No instruments available. </b-alert>
  </b-tab>
</template>

<script>
import ScheduleSelectButton from "./ScheduleSelectButton";
import InstrumentInstanceCollection from "@/collections/lab/InstrumentInstanceCollection";
import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "InstrumentSelector",

  components: { ScheduleSelectButton },

  props: {
    collection: {
      type: Object,
      default: () => null,
    },
    process: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    ...mapGetters({ schedule_form: "scheduleForm" }),
    selected_instruments() {
      let selected = this.schedule_form.processes.find(
        (process) => process.process.id === this.process.id
      ).instruments;
      return selected;
    },
    selected_tools() {
      return (
        (this.selected_instruments.length &&
          this.selected_instruments.find(
            (tool_set) => tool_set.collection.id === this.collection.id
          )) ||
        null
      );
    },
    is_all_checked() {
      return (
        (this.selected_tools &&
          this.selected_tools.tools.models.length ===
          this.selected_tools.collection.instrument_instances.length) ||
        (this.selected_tools &&
          this.selected_tools.tools.models.length === this.instrument_collection.models.length) ||
        false
      );
    },
    amount_selected() {
      // figure out the key of the selected instruments list
      let key = this.selected_instruments.length === 1 ? 0 : this.$vnode.key
      return this.selected_instruments[key] ? this.selected_instruments[key].tools.models.length : 0;
    },
    instrumentlessInstrument() {
      // Return null insturment representing tasks with now equipment requirements.
      return new InstrumentInstanceModel({
        "id": null,
        "name": "No Equipment"
      });
    }
  },

  data() {
    return {
      instrument_collection: new InstrumentInstanceCollection(),
    };
  },
  mounted() {
    // select all the instuments if there is only one avaliable OR if there are none (instrumentless/no equipment)
    if (this.instrument_collection.models.length === 1 || this.instrument_collection.models.length === 0) {
      this.handleToggleAllClick()
    }
  },
  methods: {
    ...mapActions(["UPDATE_SCHEDULE_FORM"]),
    /**
     * group scheduled instrument instance select buttons
     * should dissplay "Any {{instrument.name}}"
     */
    formatInstanceName(instrument_instance) {
      if (instrument_instance.instrument.group_schedule) {
        return "Any " + instrument_instance.instrument.name;
      } else {
        return instrument_instance.identifier;
      }
    },
    handleFormUpdate(instrument) {

      let instrument_list_update = this.selected_instruments;

      if (this.selected_tools) {
        if (this.selected_tools.tools.hasByID(instrument)) {
          let update = new InstrumentInstanceCollection();
          this.selected_tools.tools.each((item) => {
            item.id !== instrument.id && update.add(item);
          });
          instrument_list_update = this.selected_instruments.map(
            (instrument_list) => {
              if (instrument_list.collection.id === this.collection.id) {
                return {
                  collection: this.collection,
                  tools: update,
                };
              }
              return instrument_list;
            }
          );
        } else {
          this.selected_tools.tools.add(instrument);
        }
      } else {
        let new_tool_set = new InstrumentInstanceCollection();
        new_tool_set.add(instrument);
        instrument_list_update = [
          ...instrument_list_update,
          {
            collection: this.collection,
            tools: new_tool_set,
          },
        ];
      }
      this.updateStore(instrument_list_update);
    },
    handleToggleAllClick() {
      let instrument_list_update = this.selected_instruments;
      const empty_tool_set = new InstrumentInstanceCollection();
      let full_tool_set;

      if (this.collection.inspecific_scheduling && !this.collection.instrument_instances.length) {
        full_tool_set = new InstrumentInstanceCollection();
        full_tool_set.add(this.instrumentlessInstrument);

      } else {
        full_tool_set = this.collection.instrument_instances.reduce(
          (acc, cur) => {
            acc.add(cur);
            return acc;
          },
          new InstrumentInstanceCollection()
        );
      }

      if (this.is_all_checked) {
        this.selected_tools.tools = empty_tool_set;
      } else {
        if (this.selected_tools) {
          this.selected_tools.tools = this.instrument_collection.models.length === 1 ? this.instrument_collection : full_tool_set;
        } else {
          instrument_list_update = [
            ...instrument_list_update,
            {
              collection: this.collection,
              tools: this.instrument_collection.models.length === 1 ? this.instrument_collection : full_tool_set,
            },
          ];
        }
      }
      this.updateStore(instrument_list_update);
    },
    updateStore(instrument_list_update) {
      this.UPDATE_SCHEDULE_FORM({
        field: "processes",
        value: this.schedule_form.processes.map((process) => {
          if (process.process.id === this.process.id) {
            return {
              process: this.process,
              instruments: instrument_list_update,
            };
          }
          return process;
        }),
      });
    },
  },
  beforeMount() {
    this.collection.instrument_instances.forEach((instance, index) => {
      // if the parent instrument is set to 'group_schedule': only display the first istrument instance.
      if (!instance.instrument.group_schedule || index === 0) {
        this.instrument_collection.add(new InstrumentInstanceModel(instance));
      }
    });
  },
};
</script>
